/**
 * Analisi del rischio
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 3.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {ChecklistDTO} from '../model/checklistDTO';
import {EditChecklistDTO} from '../model/editChecklistDTO';
import {SuccessfulResponseBoolean} from '../model/successfulResponseBoolean';
import {SuccessfulResponseChecklist} from '../model/successfulResponseChecklist';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ChecklistControllerService {

	protected basePath = 'http://localhost:5003';
	public defaultHeaders = new HttpHeaders();
	public configuration = new Configuration();

	constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
		if (basePath) {
			this.basePath = basePath;
		}
		if (configuration) {
			this.configuration = configuration;
			this.basePath = basePath || configuration.basePath || this.basePath;
		}
	}

	/**
	 * @param consumes string[] mime-types
	 * @return true: consumes contains 'multipart/form-data', false: otherwise
	 */
	private canConsumeForm(consumes: string[]): boolean {
		const form = 'multipart/form-data';
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	}


	/**
	 * Effettua la creazione di una checklist
	 *
	 * @param body
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public createNewChecklist(body: ChecklistDTO, observe?: 'body', reportProgress?: boolean): Observable<SuccessfulResponseChecklist>;
	public createNewChecklist(body: ChecklistDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SuccessfulResponseChecklist>>;
	public createNewChecklist(body: ChecklistDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SuccessfulResponseChecklist>>;
	public createNewChecklist(body: ChecklistDTO, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

		if (body === null || body === undefined) {
			throw new Error('Required parameter body was null or undefined when calling createNewChecklist.');
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
			'application/json'
		];
		const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}

		return this.httpClient.request<SuccessfulResponseChecklist>('post', `${this.basePath}/api/v1/checklist`,
			{
				body: body,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
	 * Effettua la cancellazione di una checklist
	 *
	 * @param id Imposta filtro su campo id
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public deleteChecklist(id: number, observe?: 'body', reportProgress?: boolean): Observable<SuccessfulResponseBoolean>;
	public deleteChecklist(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SuccessfulResponseBoolean>>;
	public deleteChecklist(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SuccessfulResponseBoolean>>;
	public deleteChecklist(id: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

		if (id === null || id === undefined) {
			throw new Error('Required parameter id was null or undefined when calling deleteChecklist.');
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [];

		return this.httpClient.request<SuccessfulResponseBoolean>('delete', `${this.basePath}/api/v1/checklist/${encodeURIComponent(String(id))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
	 * Effettua il get di tutte checklist in anagrafica
	 *
	 * @param page numero di pagina
	 * @param size quantità degli elementi da richiedere
	 * @param id Imposta filtro su campo id
	 * @param nome Imposta filtro su campo nome
	 * @param fromCreatedAt Imposta filtro per le analisi a partire dalla data fromCreatedAt
	 * @param toCreatedAt Imposta filtro per le analisi fino alla data toCreatedAt
	 * @param fromExpiresAt Imposta filtro per le analisi a partire dalla data fromExpiresAt
	 * @param toExpiresAt Imposta filtro per le analisi fino alla data toExpiresAt
	 * @param fromModifiedAt Imposta filtro per le analisi a partire dalla data fromModifiedAt
	 * @param toModifiedAt Imposta filtro per le analisi fino alla data toModifiedAt
	 * @param codiceAnalisi Imposta filtro su campo codiceAnalisi
	 * @param descrizione Imposta filtro su campo descrizione
	 * @param stato Imposta filtro su campo stato
	 * @param ownerFullname Imposta filtro su campo ownerFullname
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public getAllChecklist(page?: number, size?: number, id?: number, nome?: string, fromCreatedAt?: Date, toCreatedAt?: Date, fromExpiresAt?: Date, toExpiresAt?: Date, fromModifiedAt?: Date, toModifiedAt?: Date, codiceAnalisi?: string, descrizione?: string, stato?: string, ownerFullname?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public getAllChecklist(page?: number, size?: number, id?: number, nome?: string, fromCreatedAt?: Date, toCreatedAt?: Date, fromExpiresAt?: Date, toExpiresAt?: Date, fromModifiedAt?: Date, toModifiedAt?: Date, codiceAnalisi?: string, descrizione?: string, stato?: string, ownerFullname?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public getAllChecklist(page?: number, size?: number, id?: number, nome?: string, fromCreatedAt?: Date, toCreatedAt?: Date, fromExpiresAt?: Date, toExpiresAt?: Date, fromModifiedAt?: Date, toModifiedAt?: Date, codiceAnalisi?: string, descrizione?: string, stato?: string, ownerFullname?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public getAllChecklist(page?: number, size?: number, id?: number, nome?: string, fromCreatedAt?: Date, toCreatedAt?: Date, fromExpiresAt?: Date, toExpiresAt?: Date, fromModifiedAt?: Date, toModifiedAt?: Date, codiceAnalisi?: string, descrizione?: string, stato?: string, ownerFullname?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


		let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
		if (page !== undefined && page !== null) {
			queryParameters = queryParameters.set('page', <any>page);
		}
		if (size !== undefined && size !== null) {
			queryParameters = queryParameters.set('size', <any>size);
		}
		if (id !== undefined && id !== null) {
			queryParameters = queryParameters.set('id', <any>id);
		}
		if (nome !== undefined && nome !== null) {
			queryParameters = queryParameters.set('nome', <any>nome);
		}
		if (fromCreatedAt !== undefined && fromCreatedAt !== null) {
			queryParameters = queryParameters.set('fromCreatedAt', <any>fromCreatedAt.toISOString());
		}
		if (toCreatedAt !== undefined && toCreatedAt !== null) {
			queryParameters = queryParameters.set('toCreatedAt', <any>toCreatedAt.toISOString());
		}
		if (fromExpiresAt !== undefined && fromExpiresAt !== null) {
			queryParameters = queryParameters.set('fromExpiresAt', <any>fromExpiresAt.toISOString());
		}
		if (toExpiresAt !== undefined && toExpiresAt !== null) {
			queryParameters = queryParameters.set('toExpiresAt', <any>toExpiresAt.toISOString());
		}
		if (fromModifiedAt !== undefined && fromModifiedAt !== null) {
			queryParameters = queryParameters.set('fromModifiedAt', <any>fromModifiedAt.toISOString());
		}
		if (toModifiedAt !== undefined && toModifiedAt !== null) {
			queryParameters = queryParameters.set('toModifiedAt', <any>toModifiedAt.toISOString());
		}
		if (codiceAnalisi !== undefined && codiceAnalisi !== null) {
			queryParameters = queryParameters.set('codiceAnalisi', <any>codiceAnalisi);
		}
		if (descrizione !== undefined && descrizione !== null) {
			queryParameters = queryParameters.set('descrizione', <any>descrizione);
		}
		if (stato !== undefined && stato !== null) {
			queryParameters = queryParameters.set('stato', <any>stato);
		}
		if (ownerFullname !== undefined && ownerFullname !== null) {
			queryParameters = queryParameters.set('ownerFullname', <any>ownerFullname);
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [];

		return this.httpClient.request<any>('get', `${this.basePath}/api/v1/checklist`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
	 * Effettua la retrieve di una checklist per id
	 *
	 * @param id Imposta filtro su campo id
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public getChecklistById(id: number, observe?: 'body', reportProgress?: boolean): Observable<SuccessfulResponseChecklist>;
	public getChecklistById(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SuccessfulResponseChecklist>>;
	public getChecklistById(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SuccessfulResponseChecklist>>;
	public getChecklistById(id: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

		if (id === null || id === undefined) {
			throw new Error('Required parameter id was null or undefined when calling getChecklistById.');
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [];

		return this.httpClient.request<SuccessfulResponseChecklist>('get', `${this.basePath}/api/v1/checklist/${encodeURIComponent(String(id))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
	 * Effettua la modifica di una checklist
	 *
	 * @param body
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public modifyChecklist(body: EditChecklistDTO, observe?: 'body', reportProgress?: boolean): Observable<SuccessfulResponseChecklist>;
	public modifyChecklist(body: EditChecklistDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SuccessfulResponseChecklist>>;
	public modifyChecklist(body: EditChecklistDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SuccessfulResponseChecklist>>;
	public modifyChecklist(body: EditChecklistDTO, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

		if (body === null || body === undefined) {
			throw new Error('Required parameter body was null or undefined when calling modifyChecklist.');
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
			'application/json'
		];
		const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}

		return this.httpClient.request<SuccessfulResponseChecklist>('put', `${this.basePath}/api/v1/checklist`,
			{
				body: body,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

}
